import { Action } from '@ngrx/store';
import { Driver, DriverName } from '@models/*';

export class InitDriverData implements Action {
    readonly type = CoreActionTypes.INIT_DRIVER_DATA;
}

export class RefreshDriverData implements Action {
    readonly type = CoreActionTypes.REFRESH_DRIVER_DATA;
}

export class StoreUserProfile implements Action {
    readonly type = CoreActionTypes.STORE_USER_PROFILE;

    constructor(public payload: { [k: string]: any }) {
    }
}

export class StoreDriver implements Action {
    readonly type = CoreActionTypes.STORE_DRIVER;

    constructor(public payload: Driver) {
    }
}

export class StoreToken implements Action {
    readonly type = CoreActionTypes.STORE_TOKEN;

    constructor(public payload: string) {
    }
}

export class WakeUpServiceWorkers implements Action {
    readonly type = CoreActionTypes.WAKE_UP_SERVICE_WORKERS;
}

export class SetOfflineStatus implements Action {
    readonly type = CoreActionTypes.SET_OFFLINE_STATUS;

    constructor(public payload: boolean) {
    }
}

export class SetOnlineReturning implements Action {
    readonly type = CoreActionTypes.SET_ONLINE_RETURNING;
}

export class BackOnline implements Action {
    readonly type = CoreActionTypes.BACK_ONLINE;
}

export class CompleteAppInit implements Action {
    readonly type = CoreActionTypes.COMPLETE_APP_INIT;
}

export class InitApp implements Action {
    readonly type = CoreActionTypes.INIT_APP;
}

export class InitOnlineFlow implements Action {
    readonly type = CoreActionTypes.INIT_ONLINE_FLOW;
}

/**
 * Expects user profile to have been persisted to local storage, so it can be retrieved on refresh in offline mode.
 */
export class InitOfflineFlow implements Action {
    readonly type = CoreActionTypes.INIT_OFFLINE_FLOW;
}

export class InitAuth implements Action {
    readonly type = CoreActionTypes.INIT_AUTH;
}

export class InitLang implements Action {
    readonly type = CoreActionTypes.INIT_LANG;
}

export class SetLang implements Action {
    readonly type = CoreActionTypes.SET_LANG;

    constructor(public payload: { lang: string, initial: boolean }) {
    }
}

export class SetLangSuccess implements Action {
    readonly type = CoreActionTypes.SET_LANG_SUCCESS;
    constructor(public payload: { lang: string, initial: boolean }) {
    }
}

export class SetLangFail implements Action {
    readonly type = CoreActionTypes.SET_LANG_FAIL
    constructor(public payload: { error: any }) {
    }
}

export class Logout implements Action {
    readonly type = CoreActionTypes.LOGOUT;
}

export class OfflineHydrateStore implements Action {
    readonly type = CoreActionTypes.OFFLINE_HYDRATE_STORE;
}

/**
 * Preserves the name of the driver on refreshing the app.
 */
export class SaveDriverName implements Action {
    readonly type = CoreActionTypes.SAVE_DRIVER_NAME;

    constructor(public payload: DriverName) {
    }
}

export enum CoreActionTypes {
    'INIT_DRIVER_DATA' = 'INIT_DRIVER_DATA',
    'REFRESH_DRIVER_DATA' = 'REFRESH_DRIVER_DATA',
    'STORE_USER_PROFILE' = 'STORE_USER_PROFILE',
    'STORE_DRIVER' = 'STORE_DRIVER',
    'STORE_TOKEN' = 'STORE_TOKEN',
    'WAKE_UP_SERVICE_WORKERS' = 'WAKE_UP_SERVICE_WORKERS',
    'SET_OFFLINE_STATUS' = 'SET_OFFLINE_STATUS',
    'SET_ONLINE_RETURNING' = 'SET_ONLINE_RETURNING',
    'BACK_ONLINE' = 'BACK_ONLINE',
    'COMPLETE_APP_INIT' = 'COMPLETE_APP_INIT',
    'INIT_APP' = 'INIT_APP',
    'INIT_ONLINE_FLOW' = 'INIT_ONLINE_FLOW',
    'INIT_OFFLINE_FLOW' = 'INIT_OFFLINE_FLOW',
    'INIT_AUTH' = 'INIT_AUTH',
    'INIT_LANG' = 'INIT_LANG',
    'SET_LANG' = 'SET_LANG',
    'SET_LANG_SUCCESS' = 'SET_LANG_SUCCESS',
    'SET_LANG_FAIL' = 'SET_LANG_FAIL',
    'OFFLINE_HYDRATE_STORE' = 'OFFLINE_HYDRATE_STORE',
    'LOGOUT' = 'LOGOUT',
    'SAVE_DRIVER_NAME' = 'SAVE_DRIVER_NAME'
}

export type CoreActions =
    InitDriverData | RefreshDriverData | StoreUserProfile | StoreDriver | StoreToken | SetOfflineStatus | SetOnlineReturning | BackOnline |
    CompleteAppInit | InitApp | InitOnlineFlow | InitOfflineFlow |
    OfflineHydrateStore | InitAuth | InitLang | SetLang | SetLangSuccess | SetLangFail | SaveDriverName | Logout;
